/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict"

    export class MeevoClientType implements angular.IDirective {
        restrict = "E";
        scope = {
            clientTypeId: "=?",
            clientTypeColor: "@?",
            clientTypeDisplayName: "@?",
            clientId: "@?",
            useToast: "=?",
            peekAlert: "=?",
            clientTypeIdString: "@?",
            shouldDisplayClient: "=?",
            hasClientType: "=?"
        };

        templateUrl = "app/components/controls/clientTypeTemplate.html";

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
            private $mdToast: angular.material.IToastService,
            private $translate: angular.translate.ITranslateService) { }

        link = (scope: any, element: JQuery) => {
            let dataService = this.dataService;

            // useToast should default to true if not supplied
            if (scope.useToast == undefined || scope.useToast == null) {
                scope.useToast = true;
            }

            if (!scope.useToast) {
                scope.ctrlTitle = scope.clientTypeDisplayName;
                angular.element(element).find(".client-type").removeAttr("ng-click").unbind('click').css("cursor", "default");
            }

            // Watch the client Type Id for changes and update the scope.clientType object appropriately
            scope.$watch('clientTypeId', clientTypeId => {
                getClientType(clientTypeId);
            });

            scope.$watch('clientTypeIdString', clientTypeId => {
                if (!clientTypeId) {
                    return;
                }
                getClientType(clientTypeId);
            });

            scope.$watch('clientId', clientId=> {
                if (clientId) {
                    dataService.customMethodData(`/api/client/${clientId}/clienttypes`, "get", null).then(response => {
                        if (response.data.length) {
                            scope.clientTypeId = response.data[0].id;
                            scope.raiseHasClientType();
                        }
	                });
                }
            });

            function getClientType(clientTypeId) {
                if (clientTypeId) {
                    let clientTypeIdTemp = new Guid(clientTypeId);
                    dataService.getItem("clientClientType", clientTypeIdTemp).then((results: any) => {
                        scope.clientType = results;
                        scope.ctrlTitle = scope.clientType.displayName;
                        scope.raiseHasClientType();
                    });
                }
            }

            scope.raiseHasClientType = () => {
                if (scope.hasClientType && _(scope.hasClientType).isFunction()) {
                    scope.hasClientType();
                }
            }

            // Set the indicator style function
            scope.indicatorStyle = () => {
	            const fillColor = scope.clientTypeColor
		            ? scope.clientTypeColor
		            : scope.clientType
			            ? scope.clientType.color
						: 'black';

                    return {
                        'fill': fillColor
                    };
                }

            scope.getPeekStyle = () => {
                if (scope.clientType) {
                    return {
                        'background-color': scope.clientType.color
                    };
                }
                else {
                    return {
                        'background-color': '#000000'
                    }
                }
            }

            scope.showClientTypeSmall = () => {
	            if (scope.useToast) {
                    scope.shouldDisplayClient = !scope.shouldDisplayClient;
                    console.log(scope.shouldDisplayClient);
                }
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService, $mdToast, $translate) => {
                return new MeevoClientType(dataService, $mdToast, $translate);
            };

            directive.$inject = ["meevo.components.common.DataService", "$mdToast", "$translate"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoClientType", MeevoClientType.factory())
}